import React, { useEffect, useState } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import { useSelector } from "../../../components/hooks/hooks";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import {
  FiCheckCircle,
  FiClock,
  FiPlusCircle,
  FiXCircle,
} from "react-icons/fi";
import { FcHighPriority } from "react-icons/fc";
import { toast, ToastContainer } from "react-toastify";
import { backendApi } from "../../../api/apiService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
export default function SourceReport() {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.login);
  console.log("🚀 ~ userDetails:", userDetails);
  const [menuClick, setMenuClick] = useState(false);
  const [sourceReport, setSourceReport] = useState([]);
  const [startDate, setStartDate] = useState(moment().subtract(2, 'months').toDate());
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    // getSchedulRerecruitmentReports();
    getSourceReport(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))
  }, [startDate, endDate]);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };


  const getSourceReport = (startDate = "2024-01-01", endDate = "2024-12-01") => {
    const api = {
      "functionName": "sourceReport",
      "site_id": userDetails[0].site_id,
      "startDate": startDate,
      "endDate": endDate
    }
    backendApi(api).then((response) => {
      console.log("🚀 ~ backendApi ~ response:", response)
      if (response.success === 1) {
        let finalArray = []
        for (const obj of response.dataSet) {
          let monthId = new Date(obj.MONTH).getMonth()
          console.log("🚀 ~ backendApi ~ obj:", obj)

          if (finalArray.length === 0 || !finalArray.some((item) => item?.monthId === monthId)) {
            let data = {
              "sourceList": [{ source: obj.source && obj.source !== "" && obj.source !== "undefined" ? obj.source : "Not Available", cnt: obj.cnt }],
              "date": obj.MONTH,
              "monthId": monthId
            }
            finalArray.push(data)
          } else {
            finalArray = finalArray.map((data) => {
              if (data.monthId === monthId) {
                data.sourceList.push({ source: obj.source && obj.source !== "" && obj.source !== "undefined" ? obj.source : "Not Available", cnt: obj.cnt })
              }
              return data;
            })
          }
        }
        console.log("🚀 ~ finalArray=finalArray.map ~ finalArray:", finalArray)

        console.log("dates", response.dataSet.map((date) => new Date(date.MONTH).getMonth()))
        const finalData = combineNotAvailableCounts(finalArray);
        console.log("🚀 ~ backendApi ~ finalData:", finalData)
        setSourceReport(finalData)
      }

    })
  }

  const combineNotAvailableCounts = (data) => {
    return data.map(item => {
      // Initialize a new object to hold the combined data
      const combinedSourceList = [];
      let notAvailableCount = 0;

      // Iterate through the sourceList to combine counts
      item.sourceList.forEach(source => {
        if (source.source === "Not Available") {
          notAvailableCount += source.cnt; // Sum the counts for "Not Available"
        } else {
          combinedSourceList.push(source); // Keep other sources as they are
        }
      });

      // If there are counts for "Not Available", add it to the combined list
      if (notAvailableCount > 0) {
        combinedSourceList.push({ source: "Not Available", cnt: notAvailableCount });
      }

      // Return the new item with the combined sourceList
      return {
        ...item,
        sourceList: combinedSourceList
      };
    });
  };


  const handleBack = () => {
    navigate('/dashboard/analytics-dashboard');
  };
  const handleDateChange = (index, value) => {
    if (index === "start") {
      setStartDate(value)
    }
    else if (index === "end") {
      if (new Date(value).getTime() < new Date(startDate).getTime()) {
        toast.warn("End Date cannot be lesser than Start Date", { containerId: "D" });
        return false
      }
      setEndDate(value)
    }
    // getSourceReport(moment(value).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))
  }
  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header
          Header="Reports"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        <div className="main-container">
          <ToastContainer
            enableMultiContainer
            containerId={"D"}
            position="bottom-right"
            autoClose={1500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <div className="card main-card">
            <div className="card-body">
              <div className="row">
                <div className="col-xxl-12 col-lg-12 col-md-6 padding-left-right-change">
                  <div className="card main-card-box">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div class="form-group">
                            <label htmlFor="fromDate" class="form-label">From</label>
                            <ReactDatePicker
                              id="fromDate"
                              className="form-control"
                              selected={startDate}
                              onChange={(date) => handleDateChange("start", date)}
                              showMonthYearPicker
                              dateFormat="MM/yyyy"
                              maxDate={new Date()}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="form-group">
                            <label htmlFor="endDate" class="form-label">To</label>
                            <ReactDatePicker
                              id="endDate"
                              className="form-control"
                              selected={endDate}
                              onChange={(date) => handleDateChange("end", date)}
                              showMonthYearPicker
                              dateFormat="MM/yyyy"
                              maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <h4 className="dash-sub-head">Source Analytics</h4>
                      <div className="table-responsive">
                        <table className="table mb-0">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Date</th>
                              <th>Source & Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sourceReport.length > 0 ? (
                              <>
                                {sourceReport.map((openings, index) => {
                                  return (
                                    <tr key={`sourceReport_${index}`}>
                                      <td>{index + 1}</td>
                                      <td>
                                        {openings.date}
                                      </td>
                                      <td>
                                        {openings.sourceList.length > 0 ? (
                                          <>
                                            {openings.sourceList.map((opn) => {
                                              return (
                                                <table className="table mb-0">
                                                  <td>
                                                    <tr>
                                                      <td className="py-1 px-0 border-0">
                                                        {opn.source} -{" "}
                                                        {opn.cnt}
                                                      </td>
                                                    </tr>
                                                  </td>
                                                </table>
                                              );
                                            })}
                                          </>
                                        ) : (
                                          <p>Not Available</p>
                                        )}
                                      </td>

                                    </tr>
                                  );
                                })}
                              </>
                            ) : (
                              <p>No Openings found</p>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            type="button"
            className="floating-back-button"
            onClick={handleBack}
          >
            <BsArrowLeftCircleFill size={24} />
          </button>
        </div>
      </div>
    </div>
  );
}
